export default __webpack_public_path__ + "static/media/LearningHowToLearn.5a8d0780.JPG";